import colors from 'constants/colors';
import { useEffect, useState } from 'react';
import ReactQuill from 'react-quill';

type Props = {
  questionText: string;
};

export const prepareHtmlForQuill = (html: string): string => {
  if (!html) return '';

  return (
    html
      // replace span with text-align:center to p
      .replace(/<span style="[^"]*text-align\s*:\s*center;?[^"]*">/gi, '<p class="ql-align-center">')
      .replace(/<\/span>/gi, '</p>')
      // replace <b> with <strong>
      .replace(/<b>/gi, '<strong>')
      .replace(/<\/b>/gi, '</strong>')
      // replace <i> with <em>
      .replace(/<i>/gi, '<em>')
      .replace(/<\/i>/gi, '</em>')
      // optional: remove unwanted unicode characters
      .replace(/&#x000d;|&#x0009;/gi, '')
  );
};

export const revertQuillToHtml = (quillHtml: string): string => {
  if (!quillHtml) return '';

  return (
    quillHtml
      .replace(/<p class=(['"])ql-align-center\1>/gi, '<span style="display:block; text-align:center;">')
      .replace(/<\/p>/gi, '</span>')
      // revert <strong> to <b>
      .replace(/<strong>/gi, '<b>')
      .replace(/<\/strong>/gi, '</b>')
      // revert <em> to <i>
      .replace(/<em>/gi, '<i>')
      .replace(/<\/em>/gi, '</i>')
  );
};

const QuestionText = ({ questionText }: Props) => {
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    setMounted(true);
  }, []);

  if (!questionText) {
    return null;
  }
  // const formatedContent = questionText.replaceAll('</p><p>', '</p><br/><p>');

  return (
    mounted && (
      <div className='mb-4'>
        <ReactQuill
          style={{ color: colors.font }}
          theme='snow'
          value={prepareHtmlForQuill(questionText)}
          readOnly
          modules={{
            toolbar: false, // Ẩn thanh toolbar
          }}
          formats={[
            'bold',
            'italic',
            'underline',
            'align', // VERY IMPORTANT for text-align support
            'header',
            'list',
            'bullet',
            'indent',
            'link',
            'image',
          ]}
        />
        {/* <div className='tw-text-lg tw-text-center' style={{ color: colors.font }} dangerouslySetInnerHTML={{ __html: formatedContent }} /> */}
      </div>
    )
  );
};

export default QuestionText;
